var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00024 1.5C5.00024 1.22386 5.2241 1 5.50024 1H10.5002C10.7764 1 11.0002 1.22386 11.0002 1.5C11.0002 1.77614 10.7764 2 10.5002 2H5.50024C5.2241 2 5.00024 1.77614 5.00024 1.5ZM12.5008 3L13.5 3C13.7761 3 14 3.22386 14 3.5C14 3.77614 13.7761 4 13.5 4L13.0002 4V13C13.0002 13.2652 12.8949 13.5196 12.7074 13.7071C12.5198 13.8946 12.2655 14 12.0002 14H4.00024C3.73503 14 3.48067 13.8946 3.29314 13.7071C3.1056 13.5196 3.00024 13.2652 3.00024 13V4L2.5 4C2.22386 4 2 3.77615 2 3.5C2 3.22386 2.22386 3 2.5 3L3.49855 3C3.49911 3 3.49968 3 3.50024 3C3.50081 3 3.50138 3 3.50194 3L12.4997 3C12.4999 3 12.5001 3 12.5002 3C12.5004 3 12.5006 3 12.5008 3ZM12.0002 4L4.00024 4V13H12.0002V4Z",
    fill: "#22264C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.b0e1c129.svg";
export { ForwardRef as ReactComponent };